import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export let startNotebook = (
  highlights,
  filters,
  highlightColors,
  chapters,
  tags,
  coursenum,
  page,
  hlCount,
  pagRate,
  message
) => {
  ReactDOM.render(
    <App
      highlights={highlights}
      filters={filters}
      highlightColors={highlightColors}
      chapters={chapters}
      tags={tags}
      coursenum={coursenum}
      page={page}
      hlCount={hlCount}
      pagRate={pagRate}
      message={message}
    />,
    document.getElementById('app')
  )
}
